import { IconS24InfoCircle24 } from '@is24/cosma-ui-icons';
import { Font } from 'is24-corecss';
import { CreditHistoryListItem } from './CreditHistoryListItem';
import type { CreditHistoryTransaction } from './types';
import { useIntl } from '@/i18n';

type CreditHistoryListProps = {
  transactions: ReadonlyArray<CreditHistoryTransaction>;
};

export const CreditHistoryList = ({ transactions }: CreditHistoryListProps) => {
  const { t } = useIntl();

  return transactions.length > 0 ? (
    transactions.map((item) => <CreditHistoryListItem key={item.id} transaction={item} />)
  ) : (
    <div className='padding-vertical-l display-flex align-items-center gap-s'>
      <IconS24InfoCircle24 width={24} height={24} color='blue' />
      <Font variant='font-body-medium-regular' className='margin-none'>
        {t({
          id: `creditsTransactionsLog.noCredits`,
          defaultMessage: 'You have not accumulated any points in the last 90 days.',
        })}
      </Font>
    </div>
  );
};
